export function storePrincipalCount(number) {

	const currentPrincipalCount = sessionStorage.getItem("principal") || 0;

	if (Number(currentPrincipalCount) !== number) {
		sessionStorage.setItem("principal", number);
	}
}


export function getPrincipalCount() {
	const data = sessionStorage.getItem("principal");

	return Number(data) || 0;
}
